import "./index.scss";

import { memo } from "react";
import { FormattedMessage } from "react-intl";

import type { ActivityLog } from "../activity_log_fragment.graphql";
import Organization from "./common/organization";

export type DocumentDeletedActivityLogFragment = ActivityLog & {
  properties: {
    document_name: string;
  };
};
type Props = {
  activityLog: DocumentDeletedActivityLogFragment;
};

export const DocumentDeletedLabel = memo(() => {
  return (
    <FormattedMessage id="b4adddac-6281-4052-812c-0167b043b7c6" defaultMessage="Document Deleted" />
  );
});

export const DocumentDeletedSummary = memo(
  ({
    activityLog: {
      properties: { document_name: documentName },
    },
  }: Props) => {
    return (
      <FormattedMessage
        id="a911e5ab-5e72-41bd-87a6-0f91c3dfe2f1"
        defaultMessage="Name: {documentName}"
        values={{ documentName }}
      />
    );
  },
);

export default memo(({ activityLog: { organizationName } }: Props) => {
  return (
    <div className="ActivityLogItemDetailType">
      <Organization organizationName={organizationName} />
    </div>
  );
});
